import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  DASHBOARD_FILES_COUNT,
} from "./actionTypes"

import {
  dashboardFilesCountSuccess,
  dashboardFilesCountError,
} from "./actions"

import {
  apiGetDashboardFilesCount,
} from "../../api/calls/dashboard"

function* dashboardFilesCount({payload: data}) {
  try {
    const response = yield call(apiGetDashboardFilesCount, data)
    yield put(dashboardFilesCountSuccess(response))
  } catch (error) {
    yield put(dashboardFilesCountError(error))
  }
}

export function* watchDashboardFilesCount() {
  yield takeEvery(DASHBOARD_FILES_COUNT, dashboardFilesCount);
}

function* dashboardSaga() {
  yield all([
    fork(watchDashboardFilesCount),
  ]);
}

export default dashboardSaga
